import { User } from "src/app/models/user";

export class UnsuccessRegistration {
    rUid: string;
    user: User;
    date: string;
    reason: String;

    constructor(obj) {
        this.rUid = obj.rUid;
        this.user = new User(obj.user);
        this.date = obj.date;
        this.reason = obj.reason;
    }
}